import api from "./axios";

// Signed identity for the Support Hub chat widget. The axios interceptor
// unwraps the envelope, so this resolves to `{ status, data: {...} }` and the
// fields live at `res.data`.
export const getSupportWidgetIdentity = () => api.get("/support-widget");
